<template>
  <div>
    <div v-if="loading">
      <b-spinner variant="primary"></b-spinner>
    </div>
    <div v-if="links.length > 0">
      <ul class="list-unstyled">
        <li v-for="l in links" :key="l.id">
          <b-button variant="link" :href="l.link" target="_blank" class="text-left">{{l.title}}<b-icon icon="box-arrow-in-up-right" class="ml-3"></b-icon></b-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Api from '@/api/Api'

export default {
  props: [ 'id' ],
  data () {
    return {
      loading: true,
      links: []
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      var vm = this
      vm.loading = true
      Api().get(`Course/${vm.id}/Links`)
        .then((r) => {
          vm.links = r.data
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.loading = false
          vm.$emit('dataLoaded', vm.links)
        })
    }
  }
}
</script>

<style>

</style>
